/* eslint-disable class-methods-use-this */
if (!customElements.get("highlighted-text")) {
  class HighlightedText extends HTMLElement {
    connectedCallback() {
      // Only process if the content is not already defined
      if (this.innerHTML.includes("highlighted-text__part--highlighted")) {
        return; // Skip if it's already highlighted
      }
      // Grab the attributes from the component
      const text = this.getAttribute("text");
      const highlightedText = this.getAttribute("highlighted-text");
      const color = this.getAttribute("color") || "var(--background-color--default)";
      const classes = this.getAttribute("classes") || "";
      const colorHighlight = this.getAttribute("color-highlight") || "var(--color--primary)";
      const tag = this.getAttribute("tag") || "span"; // Default to 'span' if no tag is provided

      // Highlight the text and set it to the inner HTML
      this.innerHTML = this.createHighlightedText(text, classes, highlightedText, colorHighlight, color, tag);
    }

    // Method to decode HTML entities while preserving HTML tags
    decodeHTML(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }

    // Method to strip HTML tags for comparison
    stripHTML(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    }

    // Method to create the highlighted text and wrap it in a specified tag
    createHighlightedText(text, classes, highlightedText, colorHighlight, color, tag) {
      if (!text || !highlightedText) return '';

      // Decode HTML entities in the text while preserving HTML tags
      const decodedText = this.decodeHTML(text);
      
      // For comparison, we need text without HTML tags
      const plainText = this.stripHTML(decodedText);
      const plainHighlight = this.stripHTML(highlightedText);

      // Normalize accents and special characters for comparison
      const normalizeText = (str) => {
        return str.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '') // Remove accents
          .toLowerCase();
      };

      const normalizedText = normalizeText(plainText);
      const normalizedHighlight = normalizeText(plainHighlight);

      // Find the position of the normalized highlight in the normalized text
      const startIndex = normalizedText.indexOf(normalizedHighlight);
      
      if (startIndex === -1) return decodedText; // If no match found, return original text

      // Calculate the actual HTML string positions by counting non-HTML content
      let htmlStartIndex = 0;
      let currentPlainIndex = 0;
      let htmlContent = decodedText;
      
      while (currentPlainIndex < startIndex && htmlStartIndex < htmlContent.length) {
        const char = htmlContent[htmlStartIndex];
        if (char === '<') {
          // Skip HTML tag
          const tagEnd = htmlContent.indexOf('>', htmlStartIndex);
          if (tagEnd !== -1) {
            htmlStartIndex = tagEnd + 1;
            continue;
          }
        }
        currentPlainIndex++;
        htmlStartIndex++;
      }

      // Find the end position in the HTML content
      let htmlEndIndex = htmlStartIndex;
      let remainingChars = plainHighlight.length;
      
      while (remainingChars > 0 && htmlEndIndex < htmlContent.length) {
        const char = htmlContent[htmlEndIndex];
        if (char === '<') {
          // Skip HTML tag
          const tagEnd = htmlContent.indexOf('>', htmlEndIndex);
          if (tagEnd !== -1) {
            htmlEndIndex = tagEnd + 1;
            continue;
          }
        }
        remainingChars--;
        htmlEndIndex++;
      }

      // Create the highlighted HTML
      const beforeText = htmlContent.slice(0, htmlStartIndex);
      const highlightedPart = `<span class="highlighted-text__part--highlighted" style="color: ${colorHighlight};" role="mark">${htmlContent.slice(htmlStartIndex, htmlEndIndex)}</span>`;
      const afterText = htmlContent.slice(htmlEndIndex);

      // Return the full text with the highlighted part inside the specified tag
      return `<${tag} class="highlighted-text ${classes}" style="color:${color};">${beforeText}${highlightedPart}${afterText}</${tag}>`;
    }
  }

  // Define the custom element
  customElements.define("highlighted-text", HighlightedText);
}